import { AppLink } from '@frontend/settings-routing';
import { Breadcrumbs as DesignBreadcrumbs } from '@frontend/design-system';
import { DefaultBreadcrumbsObj } from '../../types';
import { BreadcrumbsStyles } from './breadcrumbs.styles';

export type BreadcrumbsProps = { breadcrumbs?: DefaultBreadcrumbsObj[] };

export function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
  if (!breadcrumbs) {
    return null;
  }

  return (
    <DesignBreadcrumbs className={BreadcrumbsStyles.breadcrumbsDesignBreadcrumbsStyle1}>
      {breadcrumbs.map(({ to, label, ...rest }) => (
        <DesignBreadcrumbs.Path key={label} as={AppLink} to={to} {...rest}>
          {label}
        </DesignBreadcrumbs.Path>
      ))}
    </DesignBreadcrumbs>
  );
}
